import React from 'react';
import Slider from 'react-slick';
import withStyles from 'isomorphic-style-loader/withStyles';
import {
    Grid,
    Image
} from 'react-bootstrap';
import cx from 'classnames';
import { useIntl } from 'react-intl';

import LocationSearchForm from '../LocationSearchForm';
import VideoSearchForm from '../VideoSearchForm/VideoSearchForm';

import { photosShow } from '../../../helpers/photosShow';
import { homebanneruploadDir } from '../../../config';
import getDynamicHomeValue from '../../../helpers/GetDynamicItemName/dynamicHomeValue';

import carone from './carbanner.jpg';
import arrow from './arrow-down.png';

import cs from '../../commonStyle.css';
import s from './SliderAnimation.css';

const SliderAnimation = ({ data: { loading, getBanner }, layoutType }) => {

    const scrollTop = () => {
        window.scrollTo({
            top: screen.height,
            behavior: 'smooth'
        })
    }
    const settings = {
        vertical: true,
        dots: false,
        fade: true,
        infinite: true,
        speed: 6000,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        draggable: false,
        touchMove: false,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    // slidesToShow: 3,
                    // slidesToScroll: 3,
                    infinite: true,
                    dots: false,
                    fade: true,
                    pauseOnHover: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    // slidesToShow: 3,
                    // slidesToScroll: 1,
                    initialSlide: 0,
                    swipe: true,
                    swipeToSlide: true,
                    touchMove: true,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    swipe: true,
                    swipeToSlide: true,
                    touchMove: true,
                    centerMode: true


                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    initialSlide: 0,
                    swipe: true,
                    swipeToSlide: true,
                    touchMove: true,
                    centerMode: true


                }
            }
        ]
    };
    let path = photosShow(homebanneruploadDir);
    const { locale } = useIntl();


    const { title, content } = getDynamicHomeValue(getBanner, locale);

    return (
        <div>
            <div className={cx(s.layoutOneAndThreeHomeBanner)}>
                <div className={cx(s.layoutOneAndThreeBgSize)}>
                    <div className={cx(s.layoutOneAndThreeBgImg)} style={{ backgroundImage: `url(${path}${getBanner && getBanner.image})` }}>
                    </div>
                    {
                        layoutType && layoutType == 1 &&
                        <div className={s.container}>
                            {
                                !loading && getBanner &&
                                <div className={cx(s.layoutOneBannerSection,)}>
                                    <div className={s.searchbox}>
                                        <LocationSearchForm id={'layoutOne'} />
                                    </div>
                                    <h1 className={cx(s.noMargin, s.bannerCaptionText)}>
                                        {title}
                                    </h1>
                                    <p>{content}</p>
                                </div>
                            }
                        </div>
                    }
                    {
                        layoutType && layoutType == 3 &&
                        <div>
                            {
                                !loading && getBanner &&
                                <div className={s.container}>
                                    <div className={s.layoutThreeFormContainer}>
                                        <div className={cx(s.layoutThreeFormSection)}>
                                            <h1 className={cx(cs.commonTitleText, cs.fontWeightBold, s.formHeading)}>
                                                {title}
                                            </h1>
                                            <p className={s.layoutFormPara}>{content}</p>
                                            <VideoSearchForm id={'layoutThree'} />
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    }

                    <div className={s.downArrow}>
                        <div className={'visible-xs'}>
                            <Image src={arrow} responsive onClick={scrollTop} />
                        </div>
                    </div>

                </div>
            </div>
            <div className={cx('homeSliderMobile', 'hidden-sm hidden-xs', 'visible-xs visible-sm', 'hidden-md hidden-lg')}>
                <div className={s.homePosition}>
                    <div className={s.homeCarsoual}>
                        <Slider {...settings}>
                            <div className={s.bgHeight}>
                                <div className="sliderBg" style={{ backgroundImage: `url(${carone})` }} />
                            </div>
                        </Slider>
                        <div className={s.downArrow}>
                            <div className={'visible-xs'}>
                                <Image src={arrow} responsive onClick={scrollTop} />
                            </div>
                        </div>
                    </div>
                    {
                        layoutType && layoutType == 1 && <Grid>
                            {
                                !loading && getBanner && <div className={s.sliderContent}>
                                    <h1 className={cx(s.noMargin, s.bannerCaptionText)}>
                                        {title}
                                    </h1>
                                    <p>{content}</p>
                                    <div className={s.searchbox}>
                                        <LocationSearchForm id={'layoutOne'} />
                                    </div>
                                </div>
                            }
                        </Grid>
                    }
                    {
                        layoutType && layoutType == 3 && <div className={cx(s.container, s.height100)}>
                            <div className={s.FormBookWrap}>
                                {
                                    !loading && getBanner && <div className={cx(s.BookWrap, 'BookWrapRTL')}>
                                        <h1>{title}</h1>
                                        <p>{content}</p>
                                        <VideoSearchForm id={'layoutThree'} />
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </div>

            </div>
        </div>
    );
}

export default withStyles(cs, s)(SliderAnimation);
